var _path, _path2, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58154 5.49601C1.58154 3.01293 3.59447 1 6.07754 1H20.907C23.39 1 25.403 3.01293 25.403 5.496V20.3255C25.403 22.8086 23.39 24.8215 20.907 24.8215H6.07755C3.59447 24.8215 1.58154 22.8086 1.58154 20.3255V5.49601Z",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0422 5.91211C19.796 5.91476 19.5962 6.11459 19.5962 6.35943C19.5975 6.60558 19.7973 6.80542 20.0435 6.80542C20.2897 6.80542 20.4895 6.60558 20.4895 6.35943C20.4895 6.11195 20.2897 5.91211 20.0435 5.91211",
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.4928,
    cy: 12.9108,
    rx: 4.76429,
    ry: 4.7643,
    stroke: "#323232",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cf16b9c2468d6973d8998a56758aaf6d.svg";
export { ForwardRef as ReactComponent };